import SkillResult from './model';

export default SkillResult;



// WEBPACK FOOTER //
// ./data/ProgressTests/StudentProgressTestResults/SkillResults/index.js